import React from 'react'

import vehiculo from './../../../UI/canvas/CarMenu/vehiculo.svg'

import { carData as CData } from '../../../data/car.data'

import {cotizadorData as CoData} from '../../../data/cotiza.data'
import { modelsData } from '../../../data/models.data'

import backBtn from './../../../UI/canvas/CarMenu/btns/back-btn.svg'

import exit from './../../../UI/canvas/CarMenu/close.svg'

interface Props{
    isCarMenuOpened: boolean,
    selectedIndividual: string,
    contextualMenu: boolean,
    handleContextualMenu: any,
    handleSelectedMenuElement: any,
    handleBtnClick: any,
    btnSelectedIndex: number,
    showLegalNote: boolean,
    showMustangLegalNote: boolean,
    showEscapeLegalNote: boolean,
    showExplorerLegalNote: boolean,
    showBroncoLegalNote: boolean
}

interface State{
    VehicleData : any,
    btnHover: boolean,
    btnHoverIndex: number,
    btnSelectedIndex: number,
    btnSubHoverIndex: number,
    subBtnSelectedIndex:number
}

class CarMenu extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            VehicleData: CData()[0],
            btnHover: false,
            btnHoverIndex: -1,
            btnSelectedIndex: -1,
            btnSubHoverIndex: -1,
            subBtnSelectedIndex: -1
        }
    }

    componentDidUpdate(prevProps: any){
        console.log(this.props)
        if(this.props.selectedIndividual !== prevProps.selectedIndividual){
            this.setState({
                VehicleData: CData()[0][this.props.selectedIndividual],
                btnHoverIndex: -1,
                btnSelectedIndex: -1,
                btnSubHoverIndex: -1,
                subBtnSelectedIndex: -1
            })
        }
    }

    handleGenerateStructure = () => {
        if(this.props.selectedIndividual !== "" && this.state.VehicleData && this.state.VehicleData.Menu){
            return(
                this.state.VehicleData.Menu.map((data: any, index: number) => 
                        <React.Fragment key={index}>
                        {
                            index === 4 ?
                            <a href={CoData()[0][this.props.selectedIndividual]} target="_blank" style={{textDecoration: "none"}}>
                                <div 
                                    className={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? 'individual-btn-carmenu btn-hovered':'individual-btn-carmenu'} 
                                    onMouseEnter={() => {this.handleBtnHover(true, index)}} 
                                    onMouseLeave = {() => {this.handleBtnHover(false, -1)}}
                                    onClick = {() => {this.props.handleBtnClick(this.state.btnSelectedIndex === index ? -1:index, data.Slug)}}
                                    id='element-umbra-analytics' data-value={data.Nombre} data-type={"INTERFAZ"} 
                                >
                                    <img id='element-umbra-analytics' data-value={data.Nombre} data-type={"INTERFAZ"}  src={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? data.Icono2.default:data.Icono.default} alt=""/>
                                    <div id='element-umbra-analytics' data-value={data.Nombre} data-type={"INTERFAZ"}  className={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? "text-btn-carmenu-hovered":"text-btn-carmenu"}>{data.Nombre}</div>
                                </div>
                            </a>:
                            <div 
                                className={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? 'individual-btn-carmenu btn-hovered':'individual-btn-carmenu'} 
                                onMouseEnter={() => {this.handleBtnHover(true, index)}} 
                                onMouseLeave = {() => {this.handleBtnHover(false, -1)}}
                                onClick = {() => {this.props.handleBtnClick(this.state.btnSelectedIndex === index ? -1:index, data.Slug)}}
                                id='element-umbra-analytics' data-value={data.Nombre} data-type={"INTERFAZ"} 
                            >
                                <img id='element-umbra-analytics' data-value={data.Nombre} data-type={"INTERFAZ"}  src={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? data.Icono2.default:data.Icono.default} alt=""/>
                                <div id='element-umbra-analytics' data-value={data.Nombre} data-type={"INTERFAZ"}  className={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? "text-btn-carmenu-hovered":"text-btn-carmenu"}>{data.Nombre}</div>
                            </div>
                        }
                        {modelsData()[0][this.props.selectedIndividual] === undefined ? 
                            <div className={data.SubMenu.length > 0 && this.props.btnSelectedIndex === index && this.props.isCarMenuOpened ? 'container-sub-menu fade-in':'container-sub-menu-collapsed fade-out'} >
                                {data.SubMenu.map((submenu: any, indexIndv: number) => 
                                    <div 
                                        className={this.props.btnSelectedIndex === index ? this.state.subBtnSelectedIndex === indexIndv ?  'container-sub-container-selected fade-in':'container-sub-container fade-in':'container-sub-container-collapsed fade-out'}
                                        key={indexIndv}
                                        onMouseEnter = {() => {this.handleSubBtnHover(indexIndv)}}
                                        onMouseLeave = {() => {this.handleSubBtnHover(-1)}}
                                        onClick = {() => {this.handleSubBtnClick(indexIndv, data.Slug)}}
                                        id='element-umbra-analytics' data-value={submenu.Nombre.split(" ")[1]} data-type={"INTERFAZ"} 
                                    >
                                        <img id='element-umbra-analytics' data-value={submenu.Nombre.split(" ")[1]} data-type={"INTERFAZ"}  src={this.state.btnSubHoverIndex === indexIndv || this.state.subBtnSelectedIndex === indexIndv ? submenu.Icono.default:submenu.Icono2.default}></img>
                                        <div id='element-umbra-analytics' data-value={submenu.Nombre.split(" ")[1]} data-type={"INTERFAZ"}  className={this.state.btnSubHoverIndex === indexIndv || this.state.subBtnSelectedIndex === indexIndv ? 'container-sub-text-selected':'container-sub-text'}>{submenu.Nombre}</div>
                                    </div>
                                )}
                            </div>:null
                        }
                    </React.Fragment>
                )
            )
        }
    }

    handleBtnHover = (payload: boolean, index: number) => {
        this.setState({
            btnHover: payload,
            btnHoverIndex: index
        })
    }

    handleSubBtnHover = (index: number) => {
        this.setState({
            btnSubHoverIndex: index
        })
    }

    handleSubBtnClick = (index: number, payload: string) => {
        this.setState(prevState => ({
            subBtnSelectedIndex: prevState.subBtnSelectedIndex === index ? -1: index
        }), () => {
            this.props.handleSelectedMenuElement(this.props.btnSelectedIndex, payload, this.state.subBtnSelectedIndex)
        })

        
    }

    handleBtnClick = (payload: number) => {
        this.setState({
            btnSelectedIndex: payload
        }, () => {
            this.props.handleSelectedMenuElement(this.state.btnHoverIndex, -1)
        })
    }

    render(): React.ReactNode {
        return(
            <div 
                className={this.props.isCarMenuOpened && this.props.selectedIndividual !== "" ? 'carmenu-main-opened fade-in': 'carmenu-main fade-out'}
                style={{
                    pointerEvents:"none"
                }}
            >
                <div 
                    className={this.props.contextualMenu ? 'carmenu-btn-opened':'carmenu-btn'}
                    style={{pointerEvents: this.props.isCarMenuOpened && this.props.selectedIndividual !== "" ? "visibleFill":"none"}}
                    onClick={() => {this.props.handleContextualMenu()}}
                >
                    <img src={this.props.contextualMenu ? exit:vehiculo}/>
                </div>
                <div 
                    className={this.props.contextualMenu && this.props.isCarMenuOpened ? 'carmenu-cont-menu fade-in':'carmenu-cont-menu fade-out'}
                    style={{pointerEvents: this.props.contextualMenu && this.props.isCarMenuOpened  ? "visibleFill":"none"}}
                >
                    <div className='carmenu-cont-title'>
                        {this.state.VehicleData ? this.state.VehicleData.Nombre :""}
                    </div>
                    <div className='carmenu-cont-subtitle'>
                        {this.state.VehicleData  ? this.state.VehicleData.SubTitle : ""}
                    </div>
                    <div className='carmenu-btn-container'>
                        {
                            this.handleGenerateStructure()
                        }
                    </div>
                    <div className={this.props.showLegalNote ? 'edge-legal-note fade-in':'edge-legal-note fade-out'}>
                        <div className='edge-legal-title'>Imagen de referencia</div>
                        <div className='edge-legal-text'>Algunas características pueden variar con respecto al vehículo comercializado en Colombia. No incluye barras de techo y los rines varían con respecto al vehículo comercializado.</div>
                    </div>
                    <div className={this.props.btnSelectedIndex === 3 ? "back-btn fade-in":"back-btn fade-out"} onClick={() => {this.handleSubBtnClick(-1, '')}}>
                        <img src={backBtn}/>
                        <div className='btc-btn-text'>
                            Volver
                        </div>
                    </div>
                    <div className={this.props.showMustangLegalNote ? 'edge-legal-note fade-in':'edge-legal-note fade-out'}>
                        <div className='edge-legal-title'>Imagen de referencia</div>
                        <div className='edge-legal-text'>Color no comercializado en Colombia.</div>
                    </div>
                    <div className={this.props.showEscapeLegalNote ? 'edge-legal-note fade-in':'edge-legal-note fade-out'}>
                        <div className='edge-legal-title'>Imagen de referencia</div>
                        <div className='edge-legal-text'>La versión SEL 4x2 híbrida cuenta con techo solar panorámico. La versión Titanium 4x4 híbrida no equipa este elemento.</div>
                    </div>
                    <div className={this.props.showExplorerLegalNote ? 'edge-legal-note fade-in':'edge-legal-note fade-out'}>
                        <div className='edge-legal-title'>Imagen de referencia</div>
                        <div className='edge-legal-text'>La versión XLT comercializada en Colombia NO cuenta con exploradoras (luces anti-niebla).</div>
                    </div>
                    <div className={this.props.showBroncoLegalNote? 'edge-legal-note fade-in':'edge-legal-note fade-out'}>
                        <div className='edge-legal-title'>Imagen de referencia</div>
                        <div className='edge-legal-text'>La versión Wildtrak 4x4 en color Gris Carbón cuenta con techo en el mismo color de la carrocería.</div>
                    </div>
                    <div className={this.state.subBtnSelectedIndex !== -1 && this.props.btnSelectedIndex === 2 ? "back-btn fade-in":"back-btn fade-out"} onClick={() => {this.handleSubBtnClick(-1, '')}}>
                        <img src={backBtn}/>
                        <div className='btc-btn-text'>
                            Volver
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CarMenu